var now = +new Date();
var index = 0;

export default function uid() {
  return "vc-upload-" + now + "-" + ++index;
}


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-upload/src/uid.js
// module id = 385
// module chunks = 0